import React, { useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";
import "./style.css";
import img1 from "./bullet1.png";
import img2 from "./bullet2.png";
import exp from "./exportar.png";
import acp from "./aceptar.png";
import { Button } from "react-bootstrap";

//*interfaces
interface PropsTabla {
  tabla: any;
  nomA: any;
  nomH: any;
}
export default function GeneraExcel(props: PropsTabla) {
  const tablaHtml = props.tabla;
  const tableRef = useRef(null);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: props.nomA,
    sheet: props.nomH,
  });

  return (
    <div>
      <Button size="lg" variant="primary" onClick={onDownload}>
        <img src={exp} alt="" /> Exportar XLS
      </Button>
      <br />
      <div ref={tableRef}>
        <span>{props.nomH}</span>
        {tablaHtml}
      </div>
    </div>
  );
}
